import { render, staticRenderFns } from "./MultipleRadioButton.vue?vue&type=template&id=0da14e10&scoped=true"
import script from "./MultipleRadioButton.vue?vue&type=script&lang=js"
export * from "./MultipleRadioButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da14e10",
  null
  
)

export default component.exports